module.exports = __webpack_public_path__ + "assets/img/btn-view-9ed33893.png";